<template>
    <UiCoreSimpleRichText
        v-editable="blok"
        class="sb-core-simple-rich-text"
        data-test="sb-core-simple-rich-text"
        :blok="blok"
    />
</template>

<script setup lang="ts">
import type { ICoreSimpleRichText } from '~ui/types/components/CoreSimpleRichText';

defineProps<{ blok: ICoreSimpleRichText }>();
</script>

<style scoped lang="postcss">
.sb-core-simple-rich-text {
    .rich-text {
        a:hover {
            @apply brightness-[95%];
        }
    }
    &:deep(ul) {
        li {
            span:first-child.css-list-checkmarks:after {
                @apply content-[url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48IS0tIUZvbnQgQXdlc29tZSBQcm8gNi42LjAgYnkgQGZvbnRhd2Vzb21lIC0gaHR0cHM6Ly9mb250YXdlc29tZS5jb20gTGljZW5zZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tL2xpY2Vuc2UgKENvbW1lcmNpYWwgTGljZW5zZSkgQ29weXJpZ2h0IDIwMjQgRm9udGljb25zLCBJbmMuLS0+PHBhdGggZmlsbD0iI2Y2YWIzZCIgZD0iTTAgMjU2YTI1NiAyNTYgMCAxIDAgNTEyIDBBMjU2IDI1NiAwIDEgMCAwIDI1NnptMTM2IDBjMC02LjEgMi4zLTEyLjMgNy0xN2M5LjQtOS40IDI0LjYtOS40IDMzLjkgMGw0NyA0N2MzNy0zNyA3NC03NCAxMTEtMTExYzQuNy00LjcgMTAuOC03IDE3LTdzMTIuMyAyLjMgMTcgN2MyLjMgMi4zIDQuMSA1IDUuMyA3LjljLjYgMS41IDEgMi45IDEuMyA0LjRjLjIgMS4xIC4zIDIuMiAuMyAyLjJjLjEgMS4yIC4xIDEuMiAuMSAyLjVjLS4xIDEuNS0uMSAxLjktLjEgMi4zYy0uMSAuNy0uMiAxLjUtLjMgMi4yYy0uMyAxLjUtLjcgMy0xLjMgNC40Yy0xLjIgMi45LTIuOSA1LjYtNS4zIDcuOWMtNDIuNyA0Mi43LTg1LjMgODUuMy0xMjggMTI4Yy00LjcgNC43LTEwLjggNy0xNyA3cy0xMi4zLTIuMy0xNy03Yy0yMS4zLTIxLjMtNDIuNy00Mi43LTY0LTY0Yy00LjctNC43LTctMTAuOC03LTE3eiIvPjxwYXRoIGZpbGw9IndoaXRlIiBkPSJNMzY5IDE3NWM5LjQgOS40IDkuNCAyNC42IDAgMzMuOUwyNDEgMzM3Yy05LjQgOS40LTI0LjYgOS40LTMzLjkgMGwtNjQtNjRjLTkuNC05LjQtOS40LTI0LjYgMC0zMy45czI0LjYtOS40IDMzLjkgMGw0NyA0N0wzMzUgMTc1YzkuNC05LjQgMjQuNi05LjQgMzMuOSAweiIvPjwvc3ZnPg==")];
                @apply w-4 h-4 block absolute text-[#f6ab3d] -left-5 top-0 bg-white leading-[normal] rounded-[50%];
            }

            span:first-child.css-list-checkmarks {
                @apply relative pl-2;
            }
        }
    }
    :deep(.rich-text) {
        p {
            @apply text-[#666];
        }
    }
}
</style>
